import React, { useEffect, useState } from 'react';

import { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';

import EventPreview from '~/components/Event/EventPreview';
import LivestreamDataProvider from '~/components/Event/provider/LivestreamDataProvider';
import StreamPresenceDataProvider from '~/components/Event/provider/StreamPresenceDataProvider';
import FullLoader from '~/components/FullLoader';
import Layout from '~/components/Layout';
import OndemandPlayer from '~/components/Player/OndemandPlayer';
import OndemandPlayerLight from '~/components/Player/OndemandPlayerLight';
import UserMembershipNotPaidModal from '~/components/User/UserMembershipNotPaidModal';
import { withApollo } from '~/lib/apollo';
import { getOndemandSources } from '~/lib/data-transform/event-schedules';
import { useEventAccess, useFirebaseApp } from '~/lib/firebase';
import { EventServerSideProps, getCommonEventServerSideProps } from '~/lib/utils/event';
import useV2User from '~/lib/v2data';

const Index: NextPage<EventServerSideProps> = ({ event }) => {
    const eventAccess = useEventAccess({ event });

    const { userId, userIsLoading } = useFirebaseApp();
    const router = useRouter();
    const [showPreview, setShowPreview] = useState(!router.query.play);

    const { isMembershipPaymentReminded } = useV2User();

    useEffect(() => {
        if (document.location.hash === '#player') {
            setShowPreview(false);
        }
    }, []);

    const ondemandSources = getOndemandSources(event.event_schedules, 'ondemand');

    const { program_id } = router.query;

    const isOnDemandRestrictedDueToMembershipNotPayed = isMembershipPaymentReminded;

    if (userIsLoading) {
        return <FullLoader />;
    }
    return (
        <Layout>
            <Head>
                <title>OnDemand - {event.title}</title>
            </Head>
            <LivestreamDataProvider event={event} eventAccess={eventAccess}>
                <StreamPresenceDataProvider event={event}>
                    {isOnDemandRestrictedDueToMembershipNotPayed && <UserMembershipNotPaidModal />}
                    {userId && ondemandSources.length && (!showPreview || program_id) ? (
                        event.ondemand_player === 'advanced' ||
                        (!event.ondemand_player && ondemandSources.length > 1) ? (
                            <OndemandPlayer event={event} />
                        ) : (
                            <OndemandPlayerLight event={event} />
                        )
                    ) : (
                        <EventPreview event={event} closePreview={() => setShowPreview(false)} />
                    )}
                </StreamPresenceDataProvider>
            </LivestreamDataProvider>
        </Layout>
    );
};

export const getServerSideProps: GetServerSideProps<EventServerSideProps> = async (ctx) => {
    const props = await getCommonEventServerSideProps(ctx);
    return props;
};

export default withApollo()(Index);
